import BuyPackageModal from './BuyPackageModal';

export default BuyPackageModal;
